module.exports = __webpack_public_path__ + "img/photo-4.2a76fcd6.jpg";